module.exports = __webpack_public_path__ + "ec5eb9bdd70cfecd72a78f575255a3be.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/bookshelves/bookshelf-winter.png
// module id = 3392
// module chunks = 0